import { TLC_CONSTANTS } from "../../../js/lib/tlc-constants";
import { TLCLogger } from "../../../js/lib/logger";

export const ValidationManagerPlusConstants = {
  ValidatorType: {
    zipCode: 'zipCode',
    phoneNumber: 'phoneNumber',
    email: 'email',
    match: 'match',
    length: 'length',
    date: 'date'
  }
};

export const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_NUMBER_PATTERN = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
export const ZIP_CODE_PATTERN = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const DATE_PATTERN = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

export const ValidationManagerPlus = (function ($) {

  

  /* stock validators */
  var isValidPhoneNumber = function (phoneNumber) {
    return PHONE_NUMBER_PATTERN.test(phoneNumber);
  };
  var isValidZipCode = function (zipCode) {
    return ZIP_CODE_PATTERN.test(zipCode);
  };
  var isValidEmail = function (email) {
    return EMAIL_PATTERN.test(email);
  };
  var isLengthInRange = function (value, validator) {
    return value.length >= validator.minLength && value.length <= validator.maxLength;
  };
  var isAMatch = function (firstValue, validator) {
    var secondValue = getValue(validator.otherSelector);
    if (firstValue === secondValue) {
      return true;
    }
    return false;
  };
  var isValidDate = function (dateString) {
    // First check for the pattern
    if(!DATE_PATTERN.test(dateString))
      return false;

    // Parse the date parts to integers
    var parts = dateString.split("/");
    var day = parseInt(parts[1], 10);
    var month = parseInt(parts[0], 10);
    var year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if(year < 1000 || year > 3000 || month == 0 || month > 12)
      return false;

    var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

    // Adjust for leap years
    if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
      monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  };

  var errorMessages = [];

  var getDefaultValidatorOptions = function (validator) {
    var baseValidatorOptions = {
      message: 'invalid',
      check: function (inString) {
        return true;
      }
    };
    switch (validator.type) {
      case ValidationManagerPlusConstants.ValidatorType.zipCode:
        return $.extend(true, {}, baseValidatorOptions, {
          message: 'invalid zip code',//TODO Constants
          check: isValidZipCode
        }, validator);
      case ValidationManagerPlusConstants.ValidatorType.phoneNumber:
        return $.extend(true, {}, baseValidatorOptions, {
          message: 'invalid phone number',//TODO Constants
          check: isValidPhoneNumber
        }, validator);
      case ValidationManagerPlusConstants.ValidatorType.email:
        return $.extend(true, {}, baseValidatorOptions, {
          message: 'invalid email address',//TODO Constants
          check: isValidEmail
        }, validator);
      case ValidationManagerPlusConstants.ValidatorType.match:
        return $.extend(true, {}, baseValidatorOptions, {
          message: 'values do not match',//TODO Constants
          check: isAMatch
        }, validator);
      case ValidationManagerPlusConstants.ValidatorType.length:
        return $.extend(true, {}, baseValidatorOptions, {
          message: 'length out of range',//TODO Constants
          check: isLengthInRange
        }, validator);
      case ValidationManagerPlusConstants.ValidatorType.date:
        return $.extend(true, {}, baseValidatorOptions, {
          message: 'invalid date',//TODO Constants
          check: isValidDate
        }, validator);
      default:
        return $.extend(true, {}, baseValidatorOptions, validator);
    }
  };
  var getFullValidationObject = function (validationObject) {
    var baseValidationObject = {
      delegateSelector: "body",
      fields: []
    };
    validationObject = $.extend(true, {}, baseValidationObject, validationObject);
    var fields = [];
    $.each(validationObject.fields, function (i, fieldOptions) {
      var tempField = $.extend(true, {}, baseFieldOptions, fieldOptions);
      var tempValidators = [];
      $.each(tempField.validators, function (j, validator) {
        tempValidators.push($.extend(true, {}, getDefaultValidatorOptions(validator), validator.options));
      });
      tempField.validators = tempValidators;
      fields.push(tempField);
    });
    validationObject.fields = fields;
    return validationObject;
  };

  var baseFieldOptions = {
    //selector: '',//should error if this is missing
    //defaultValue: '',//used if default has a value
    required: false,
    message: 'invalid',
    requiredMessage: 'field cannot be left blank',//TODO constants
    errorClass: TLC_CONSTANTS.CssClasses.error,
    successClass: TLC_CONSTANTS.CssClasses.success,
    requiredClass: TLC_CONSTANTS.CssClasses.required,
    validators: []//phone, zipCode, custom
  };
  var isSelect = function (selector) {
    return ($(selector).get(0).tagName == "SELECT");
  }
  var isCheckBoxGroup = function(selector) {
    return ($(selector).is(':checkbox') && $(selector).attr('data-cb-group'));
  }
  var getValue = function (selector) {
    if (isSelect(selector)) {
      return $(selector).find('option:selected').val();
    } else if (isCheckBoxGroup(selector)) {
      var checkboxGroupName = $(selector).attr("data-cb-group");
      var values = new Array();
      $.each($("input[data-cb-group='"+checkboxGroupName+"']:checked"), function() {
        values.push($(this).val());
      });
      return (values.length > 0) ? values.toString() : "";
    }

    return $(selector).val();
  };
  var checkValidators = function (field) {
    errorMessages = [];
    $.each(field.validators, function (i, validator) {
      if (validator.check(getValue(field.selector), validator) !== true) {
        field.message = validator.message;
        if (validator.otherSelector) {
          onError(validator.otherSelector);
        }
        errorMessages.push(validator.message);//TODO stop at first error?
      }
    });
    if (errorMessages.length > 0) {
      TLCLogger.log("errors");
      TLCLogger.log(errorMessages);//TODO display errorMessages
      return onError(field);
    }
    else {
      return onSuccess(field);
    }
  };
  var isNotEmptyOrDefaultValue = function (value, defaultValue) {
    var notEmptyPattern = /\S/;
    if (notEmptyPattern.test(value)) {//it's not empty
      if (value != defaultValue) {
        return true;//it's not empty or the default
      }
      else {
        return false;//it's the default
      }
    }
    else {
      return false;//it's empty
    }
  };
  var onError = function (field) {
    $(field.selector).addClass(field.errorClass).removeClass(field.successClass);
    return false;
  };
  var onSuccess = function (field) {
    $(field.selector).addClass(field.successClass).removeClass(field.errorClass);
    return true;
  };
  var checkField = function (field) {
    if (isNotEmptyOrDefaultValue(getValue(field.selector), field.defaultValue)) {
      return checkValidators(field);
    }
    else {
      return (field.required === true) ? onError(field) : onSuccess(field);
    }
  };
  var keyUpOrChangeHandler = function (field) {
    return function () {
      checkField(field);
    };
  };
  return {
    setValidation: function (validationObject) {
      validationObject = getFullValidationObject(validationObject);//extend default options
      $.each(validationObject.fields, function (i, field) {
        if (field.required === true) {
          $(field.selector).addClass(field.requiredClass).each(function (i, element) {
            if (element.id != null) {
              $("label[for='" + element.id + "']").addClass(TLC_CONSTANTS.CssClasses.required);
            }
          });
        }
        $(validationObject.delegateSelector)
          .on("keyup", field.selector, keyUpOrChangeHandler(field))
          .on("change", field.selector, keyUpOrChangeHandler(field))
          .on("blur", field.selector, keyUpOrChangeHandler(field));
        //.delegate(field.selector, "focus", function(event) {
        //	$(event.currentTarget).removeClass(field.errorClass);
        //});
      });
    },
    resetValidation: function (validationObject) {
      validationObject = getFullValidationObject(validationObject);
      $(validationObject.delegateSelector).off();
    },
    validateSubmit: function (validationObject, errorCallback) {
      validationObject = getFullValidationObject(validationObject);
      var errors = [];
      $.each(validationObject.fields, function (i, field) {
        var error = checkField(field);
        if (error !== true) {
          errors.push(field.message);
        }
      });
      if (errors.length > 0) {
        if (errorCallback) errorCallback(errors);
        return false;
      }
      else {
        return true;
      }
    },
    getEmailPattern: function () {
      return EMAIL_PATTERN;
    },
    getPhoneNumberPattern: function () {
      return PHONE_NUMBER_PATTERN;
    },
    getZipCodePattern: function () {
      return ZIP_CODE_PATTERN;
    },
    getDatePattern: function () {
      return DATE_PATTERN;
    }
  };

})(jQuery);
